import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { closeStaffModal } from "../redux/features/staffModalSlice";
import AddStaff from "../Pages/Staff Managment/AddStaff";
import "../GlobalModel.css";
function StaffModal({ onSuccess }) {
  const dispatch = useDispatch();

  const { isOpen } = useSelector(
    (state) => state.staffModal
  );
  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-box">

        <div className="custom-modal-header">
          <h4>Add Employee</h4>

          <button
             className="close-btn"
            onClick={() => dispatch(closeStaffModal())}
          >
            ✕
          </button>
        </div>

        <div className="custom-modal-body">
        <AddStaff isModal={true} />
        </div>

      </div>
    </div>
  );
}

export default StaffModal;